import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { WeatherInfo } from '../types';

export const weatherApi = {
  getWeather: async (lat: number, lon: number): Promise<WeatherInfo> => {
    const response = await axios.get(
      `https://api.open-meteo.com/v1/forecast?latitude=${lat}&longitude=${lon}&current=temperature_2m,relative_humidity_2m,weather_code,wind_speed_10m&daily=temperature_2m_max,temperature_2m_min&timezone=auto&forecast_days=1`
    );

    const current = response.data.current;
    const daily = response.data.daily;

    return {
      temp: Math.round(current.temperature_2m),
      tempMin: Math.round(daily.temperature_2m_min[0]),
      tempMax: Math.round(daily.temperature_2m_max[0]),
      humidity: Math.round(current.relative_humidity_2m),
      windSpeed: Math.round(current.wind_speed_10m),
      weatherCode: current.weather_code,
    };
  },
};

export const useWeather = (lat: number = 41.2995, lon: number = 69.2401) => {
  return useQuery({
    queryKey: ['weather', lat, lon],
    queryFn: () => weatherApi.getWeather(lat, lon),
    staleTime: 30 * 60 * 1000, // 30 minutes stale time (built-in React Query caching!)
    cacheTime: 60 * 60 * 1000, // 1 hour cache time
    refetchOnWindowFocus: false, // Don't refetch when switching tabs to avoid unnecessary requests
  });
};
